/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ListOfAppsQueryVariables = {||};
export type ListOfAppsQueryResponse = {|
  +myApps: $ReadOnlyArray<{|
    +appId: number,
    +name: string,
    +appIcon: ?any,
  |}>
|};
export type ListOfAppsQuery = {|
  variables: ListOfAppsQueryVariables,
  response: ListOfAppsQueryResponse,
|};
*/


/*
query ListOfAppsQuery {
  myApps {
    appId
    name
    appIcon
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "appId",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "appIcon",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ListOfAppsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "App",
        "kind": "LinkedField",
        "name": "myApps",
        "plural": true,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ListOfAppsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "App",
        "kind": "LinkedField",
        "name": "myApps",
        "plural": true,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d9bbcf02e643d2c13ae025733c9b081c",
    "id": null,
    "metadata": {},
    "name": "ListOfAppsQuery",
    "operationKind": "query",
    "text": "query ListOfAppsQuery {\n  myApps {\n    appId\n    name\n    appIcon\n    id\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '4bdb9fa99aa41db45fcfe7ecd3d88d5a';

module.exports = node;
